var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"text":"Sign out","is-loading":_vm.isLoading,"is-text":"","on-click":_vm.logOut}})
}
var staticRenderFns = []

export { render, staticRenderFns }